'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useRef, useState } from 'react';
import { Collapsible, CollapsibleTrigger } from '@/components/ui/collapsible';
import { cn } from '@/lib/utils';
export function FilmSummary(t0) {
  const $ = _c(22);
  const {
    className,
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [showTrigger, setShowTrigger] = useState(true);
  const contentRef = useRef(null);
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => {
      const checkIfClamped = () => {
        if (contentRef.current && !isOpen) {
          const {
            scrollHeight,
            clientHeight
          } = contentRef.current;
          setShowTrigger(scrollHeight > clientHeight);
        }
      };
      checkIfClamped();
      window.addEventListener("resize", checkIfClamped);
      return () => window.removeEventListener("resize", checkIfClamped);
    };
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== isOpen) {
    t2 = [isOpen, children];
    $[2] = children;
    $[3] = isOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== className) {
    t3 = cn("relative", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !isOpen;
  let t5;
  if ($[7] !== t4) {
    t5 = cn("space-y-2 text-pretty text-sm leading-relaxed [&>p]:text-white/90 [&_span]:italic", "overflow-hidden transition-all duration-300", {
      "line-clamp-2 md:line-clamp-3": t4
    });
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t5) {
    t6 = <div ref={contentRef} className={t5}>{children}</div>;
    $[9] = children;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isOpen || $[13] !== showTrigger) {
    t7 = showTrigger && <CollapsibleTrigger className="mt-2 text-sm text-white/60 hover:text-white">{isOpen ? "show less..." : "read more..."}</CollapsibleTrigger>;
    $[12] = isOpen;
    $[13] = showTrigger;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== isOpen || $[16] !== t6 || $[17] !== t7) {
    t8 = <Collapsible open={isOpen} onOpenChange={setIsOpen}>{t6}{t7}</Collapsible>;
    $[15] = isOpen;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t8) {
    t9 = <div className={t3}>{t8}</div>;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}